(function () {
    var ENDPOINT = 'https://n8n-shaf-u71178.vm.elestio.app/webhook/cart-snapshot';
    var MUTATIONS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
    var SIG_KEY = 'sm_cart_sig';
    var debounce;

    // ── Capture session landing page + referrer ONCE per visit ──
    var landing, referrer;
    try {
      landing = sessionStorage.getItem('sm_landing');
      if (!landing) {
        landing = location.href;
        sessionStorage.setItem('sm_landing', landing);
      }
      referrer = sessionStorage.getItem('sm_referrer');
      if (referrer === null) {
        referrer = document.referrer || '';
        sessionStorage.setItem('sm_referrer', referrer);
      }
    } catch (e) {
      landing = location.href; referrer = document.referrer || '';
    }

    function isCartMutation(u) {
      if (!u) return false;
      u = String(u);
      for (var i = 0; i < MUTATIONS.length; i++) if (u.indexOf(MUTATIONS[i]) > -1) return true;
      return false;
    }

    function schedule() { clearTimeout(debounce); debounce = setTimeout(send, 800); }

    function imgOf(it) {
      var u = it.image || (it.featured_image && it.featured_image.url) || '';
      if (u && u.indexOf('//') === 0) u = 'https:' + u;
      if (u && u.indexOf('?') === -1) u = u + '?width=120';
      return u;
    }
    function optsOf(it) {
      if (it.options_with_values && it.options_with_values.length) {
        return it.options_with_values.map(function (o) { return o.value; })
          .filter(function (v) { return v && v !== 'Default Title'; }).join(' / ');
      }
      return (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    }

    function sigOf(cart) {
      var s = String(cart.token || '') + '|' + cart.item_count + '|' + cart.total_price;
      (cart.items || []).forEach(function (it) {
        s += '|' + (it.key || it.id) + ':' + it.quantity;
      });
      return s;
    }

    function push(cart) {
      try {
        var payload = {
          cart_token: cart.token,
          item_count: cart.item_count,
          total_price: (cart.total_price || 0) / 100,
          currency: cart.currency,
          items: JSON.stringify((cart.items || []).map(function (it) {
            return {
              key: it.key || String(it.id || ''),
              title: it.product_title,
              variant: optsOf(it),
              qty: it.quantity,
              price: (it.final_price || 0) / 100,
              url: it.url,
              image: imgOf(it),
              sku: it.sku || ''
            };
          })),
          landing_url: landing,
          referrer: referrer,
          page_url: location.href,
          ts: new Date().toISOString()
        };
        if (window.SM_CUSTOMER && window.SM_CUSTOMER.email) {
          payload.customer_email = window.SM_CUSTOMER.email;
          payload.customer_id = window.SM_CUSTOMER.id;
        }
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
          navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
        } else {
          fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', keepalive: true,
            headers: { 'Content-Type': 'text/plain' }, body: body });
        }
        try { localStorage.setItem(SIG_KEY, sigOf(cart)); } catch (e) {}
      } catch (e) {}
    }

    function send() {
      try {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(push)
          .catch(function () {});
      } catch (e) {}
    }

    // Intercept the AJAX calls Dawn (and theme add-to-cart) make to /cart/*.
    // v3.1: beacon from the mutation's OWN response when it contains the full
    // cart (/cart/change|update|clear return it) — instant, survives immediate
    // navigation. /cart/add returns only the added line, so fire send() right
    // away (no 800ms debounce — that window lost events). Unparseable
    // responses fall back to the debounced path.
    function handleMutationResponse(p) {
      try {
        if (p && p.token && typeof p.item_count !== 'undefined') { push(p); }
        else { clearTimeout(debounce); send(); }
      } catch (e) { schedule(); }
    }
    try {
      var of = window.fetch;
      if (of) {
        window.fetch = function () {
          var u = arguments[0]; if (u && u.url) u = u.url;
          var r = of.apply(this, arguments);
          if (isCartMutation(u)) {
            try {
              r.then(function (resp) {
                try {
                  resp.clone().json().then(handleMutationResponse).catch(schedule);
                } catch (e) { schedule(); }
              }).catch(function () {});
            } catch (e) { schedule(); }
          }
          return r;
        };
      }
      var ox = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        if (isCartMutation(u)) this.addEventListener('load', function () {
          try { handleMutationResponse(JSON.parse(this.responseText)); }
          catch (e) { schedule(); }
        });
        return ox.apply(this, arguments);
      };
    } catch (e) {}

    // ── Page-load reconcile: self-heal any snapshot the mutation path missed.
    //    Guards: cart cookie must exist; beacon only when the live cart differs
    //    from the last snapshot sent; never CREATES a row for an empty cart we
    //    have never snapshotted (but does record a tracked cart being emptied). ──
    try {
      if (/(^|;\s*)cart=/.test(document.cookie)) {
        setTimeout(function () {
          try {
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                if (!c || !c.token) return;
                var last = null;
                try { last = localStorage.getItem(SIG_KEY); } catch (e) {}
                var sig = sigOf(c);
                if (sig === last) return;
                if (c.item_count > 0 || last !== null) push(c);
              })
              .catch(function () {});
          } catch (e) {}
        }, 2500);
      }
    } catch (e) {}

    // ── Identity attach: if signed in, attach email to an existing cart once
    //    per session (covers "added to cart, THEN logged in"). Only fires when
    //    the cart already has items, so it never creates empty rows. ──
    if (window.SM_CUSTOMER && window.SM_CUSTOMER.email) {
    try {
      if (!sessionStorage.getItem('sm_idsent')) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (c && c.item_count > 0) push(c);
            try { sessionStorage.setItem('sm_idsent', '1'); } catch (e) {}
          })
          .catch(function () {});
      }
    } catch (e) {}
    }
  })();
